import { useQuery } from "@tanstack/react-query";
import { DropsApi } from "@devour/client";
import getConfig from "@/utils/getConfig";

export function useGetDropLiveStatus(slug?: string) {
    return useQuery({
        queryKey: ["drop-live-status", slug],
        queryFn: async () => {
            if (!slug) return null;
            const api = new DropsApi(getConfig());
            return (api as any).getDropsSlugSlugContentLiveStatus({ slug });
        },
        enabled: Boolean(slug),
        staleTime: 30 * 1000,
        refetchInterval: 60 * 1000,
    });
}
